import React from "react";
import NavBar from "../components/NavBar";

const FoodyPrivacyPage = ({ language, onLanguageChange, t }) => {
  const aiItems = t("foodyPrivacy.ai.items") || [];
  const thirdPartyProviders = t("foodyPrivacy.thirdParty.providers") || [];
  const disclosureItems = t("foodyPrivacy.thirdParty.disclosures") || [];

  return (
    <div className="page foody-page support-page" id="foody-privacy-top">
      <NavBar
        language={language}
        onLanguageChange={onLanguageChange}
        items={[
          { href: "/apps/foody", label: t("foodySupport.back") },
          {
            href: "/apps/foody/static/support",
            label: t("foodySupport.badge"),
          },
        ]}
      />

      <main className="foody-main">
        <section className="foody-hero support-hero">
          <div className="foody-hero-copy">
            <span className="support-pill">{t("foodyPrivacy.badge")}</span>
            <h1>{t("foodyPrivacy.hero.title")}</h1>
            <p>{t("foodyPrivacy.hero.desc")}</p>
            <p className="support-muted">
              {t("foodyPrivacy.hero.effectiveDate")}
            </p>
          </div>
        </section>

        <section className="foody-section">
          <div className="foody-grid support-grid">
            <article className="foody-card">
              <h3>{t("foodyPrivacy.provided.title")}</h3>
              <p>{t("foodyPrivacy.provided.p1")}</p>
              <p>{t("foodyPrivacy.provided.p2")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("foodyPrivacy.automatic.title")}</h3>
              <p>{t("foodyPrivacy.automatic.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("foodyPrivacy.location.title")}</h3>
              <p>{t("foodyPrivacy.location.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("foodyPrivacy.ai.title")}</h3>
              <p>{t("foodyPrivacy.ai.desc")}</p>
              <ul className="support-list">
                {aiItems.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>

            <article className="foody-card">
              <h3>{t("foodyPrivacy.thirdParty.title")}</h3>
              <p>{t("foodyPrivacy.thirdParty.p1")}</p>
              <p>{t("foodyPrivacy.thirdParty.p2")}</p>
              <ul className="support-list">
                {thirdPartyProviders.map((provider) => (
                  <li key={provider.name}>
                    <a
                      href={provider.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {provider.name}
                    </a>
                  </li>
                ))}
              </ul>
              <p className="support-muted">{t("foodyPrivacy.thirdParty.p3")}</p>
              <ul className="support-list">
                {disclosureItems.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>

            <article className="foody-card">
              <h3>{t("foodyPrivacy.optOut.title")}</h3>
              <p>{t("foodyPrivacy.optOut.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("foodyPrivacy.retention.title")}</h3>
              <p>{t("foodyPrivacy.retention.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("foodyPrivacy.children.title")}</h3>
              <p>{t("foodyPrivacy.children.p1")}</p>
              <p>{t("foodyPrivacy.children.p2")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("foodyPrivacy.security.title")}</h3>
              <p>{t("foodyPrivacy.security.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("foodyPrivacy.changes.title")}</h3>
              <p>{t("foodyPrivacy.changes.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("foodyPrivacy.consent.title")}</h3>
              <p>{t("foodyPrivacy.consent.desc")}</p>
            </article>
          </div>
        </section>

        <section className="foody-cta">
          <div>
            <h2>{t("foodyPrivacy.contact.title")}</h2>
            <p>
              {t("foodyPrivacy.contact.desc")}
              <br />
              <a href="mailto:support-foody@wodaslabs.com">
                support-foody@wodaslabs.com
              </a>
            </p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default FoodyPrivacyPage;
